import React from "react";
import TextField from "@mui/material/TextField";

interface ZipFieldProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  classes?: { textField?: string; input?: string };
  error?: string;
  label?: string;
}

function ZipField({ value, onChange, classes = {}, error }: ZipFieldProps) {
  const validate = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = evt.target;
    const regex = /^[0-9]+$/;

    if ((value.match(regex) && value.length < 6) || value === "") {
      onChange(evt);
    }
  };

  return (
    <TextField
      required
      fullWidth
      variant="outlined"
      type="text"
      name="zipcode"
      value={value}
      label="Zip Code"
      onChange={validate}
      className={classes?.textField}
      slotProps={{
        input: {
          className: classes?.input,
        },
      }}
      helperText={error}
      error={!!error}
      sx={{ bgcolor: "background.paper" }}
    />
  );
}

export default ZipField;
